var map = {
	"./": 67672,
	"./App": 73465,
	"./App.tsx": 73465,
	"./assets/images/animated_loading_icon.svg": 42327,
	"./assets/images/bg_hall_of_fame.png": 62398,
	"./assets/images/bg_hall_of_fame_item.webp": 28758,
	"./assets/images/bg_hall_of_fame_item_mobile.webp": 99075,
	"./assets/images/bg_hall_of_fame_mobile.webp": 11145,
	"./assets/images/btn_up_arrow_icon.svg": 99646,
	"./assets/images/cashback.webp": 44146,
	"./assets/images/copy_icon.svg": 82796,
	"./assets/images/cross_icon.svg": 47966,
	"./assets/images/desktop_game_cross_icon.svg": 34983,
	"./assets/images/drawer_help_icon.svg": 38909,
	"./assets/images/drawer_rules_icon.svg": 15955,
	"./assets/images/flags/flag_language_ar_icon.svg": 10779,
	"./assets/images/flags/flag_language_en_icon.svg": 70209,
	"./assets/images/flags/flag_language_fr_icon.svg": 8325,
	"./assets/images/flags/flag_language_he_icon.svg": 25838,
	"./assets/images/flags/flag_language_tr_icon.svg": 76872,
	"./assets/images/footer_privacy_icon.svg": 23156,
	"./assets/images/game_card/game_favorite_clicked_icon.svg": 74369,
	"./assets/images/game_card/game_favorite_icon.svg": 72891,
	"./assets/images/game_card/test_game_image1.webp": 63299,
	"./assets/images/game_card/test_game_image10.webp": 20732,
	"./assets/images/game_card/test_game_image11.webp": 58150,
	"./assets/images/game_card/test_game_image2.webp": 25161,
	"./assets/images/game_card/test_game_image3.webp": 25937,
	"./assets/images/game_card/test_game_image4.webp": 91645,
	"./assets/images/game_card/test_game_image5.webp": 92587,
	"./assets/images/game_card/test_game_image6.webp": 26456,
	"./assets/images/game_card/test_game_image7.webp": 42213,
	"./assets/images/game_card/test_game_image8.webp": 597,
	"./assets/images/game_card/test_game_image9.webp": 92217,
	"./assets/images/game_exit-full-screen_icon.svg": 63250,
	"./assets/images/game_exit-small-full-screen_icon.svg": 57206,
	"./assets/images/game_fullscreen_icon.svg": 4427,
	"./assets/images/game_small-full-screen_icon.svg": 22102,
	"./assets/images/games_banner_icon_izibet.webp": 36464,
	"./assets/images/games_banner_icon_megawin.webp": 95850,
	"./assets/images/games_banner_icon_mybet_desc.webp": 70575,
	"./assets/images/games_banner_icon_mybet_mob.webp": 99841,
	"./assets/images/header_drop-down-button_icon.svg": 6474,
	"./assets/images/header_facebook_logo.svg": 79721,
	"./assets/images/header_megaphone_icon.svg": 91864,
	"./assets/images/header_user-profile_icon.svg": 6221,
	"./assets/images/icons/arrow_icon.svg": 48334,
	"./assets/images/icons/back_icon.svg": 81807,
	"./assets/images/icons/cross_icon.svg": 29318,
	"./assets/images/icons/language_icon.svg": 73403,
	"./assets/images/input_closed_eye_icon.svg": 96602,
	"./assets/images/input_error_icon.svg": 41450,
	"./assets/images/input_generate_password_icon.svg": 48417,
	"./assets/images/input_opened_eye_icon.svg": 53665,
	"./assets/images/jackpot_star_bronze_desktop_icon.svg": 94517,
	"./assets/images/jackpot_star_bronze_icon.svg": 35285,
	"./assets/images/jackpot_star_gold_desktop_icon.svg": 76128,
	"./assets/images/jackpot_star_gold_icon.svg": 52345,
	"./assets/images/jackpot_star_icon.svg": 42561,
	"./assets/images/jackpot_star_icon2.svg": 44368,
	"./assets/images/jackpot_star_silver_desktop_icon.svg": 52357,
	"./assets/images/jackpot_star_silver_icon.svg": 46266,
	"./assets/images/main_arrow_icon.svg": 75312,
	"./assets/images/main_cards/games_icon.png": 48223,
	"./assets/images/main_cards/megawin_live_sport.webp": 38066,
	"./assets/images/main_cards/megawin_slots.webp": 92514,
	"./assets/images/main_cards/megawin_sport.webp": 13108,
	"./assets/images/main_cards/sport_icon.png": 25230,
	"./assets/images/main_cards/tv_games_icon.png": 83225,
	"./assets/images/main_logo_izibet_icon.svg": 32123,
	"./assets/images/main_logo_megawin_dark_icon.svg": 60365,
	"./assets/images/main_logo_mybet_dark_icon.svg": 39608,
	"./assets/images/main_logo_mybet_light_icon.svg": 42568,
	"./assets/images/menu_drawer_icon.svg": 82417,
	"./assets/images/menu_profile/megawin_menu_profile_bet_history_icon.webp": 80596,
	"./assets/images/menu_profile/megawin_menu_profile_cashback_history_icon.webp": 74338,
	"./assets/images/menu_profile/megawin_menu_profile_change_password_icon.webp": 58482,
	"./assets/images/menu_profile/megawin_menu_profile_logout_icon.webp": 15392,
	"./assets/images/menu_profile/megawin_menu_profile_messages_icon.webp": 41855,
	"./assets/images/menu_profile/megawin_menu_profile_operations_history_icon.webp": 61988,
	"./assets/images/menu_profile/megawin_menu_profile_personal_data_icon.webp": 82587,
	"./assets/images/menu_profile/menu_profile_bet_history_icon.svg": 90032,
	"./assets/images/menu_profile/menu_profile_cashback_history_icon.svg": 35326,
	"./assets/images/menu_profile/menu_profile_change_password_icon.svg": 7776,
	"./assets/images/menu_profile/menu_profile_logout_icon.svg": 17062,
	"./assets/images/menu_profile/menu_profile_messages_icon.svg": 43039,
	"./assets/images/menu_profile/menu_profile_operations_history_icon.svg": 1007,
	"./assets/images/menu_profile/menu_profile_personal_data_icon.svg": 23523,
	"./assets/images/mobile_arrow_back_icon.svg": 2568,
	"./assets/images/navbar/aj.svg": 57379,
	"./assets/images/navbar/footer_crash_icon.svg": 97524,
	"./assets/images/navbar/footer_favorite_icon.svg": 93141,
	"./assets/images/navbar/footer_virtual_icon.svg": 43722,
	"./assets/images/navbar/icon_amatic.png": 31584,
	"./assets/images/navbar/icon_crash.svg": 43470,
	"./assets/images/navbar/icon_evolution.svg": 52107,
	"./assets/images/navbar/icon_fouchika.webp": 45515,
	"./assets/images/navbar/icon_games.svg": 24519,
	"./assets/images/navbar/icon_horses.svg": 82202,
	"./assets/images/navbar/icon_live_sport.svg": 9109,
	"./assets/images/navbar/icon_nincato.png": 49372,
	"./assets/images/navbar/icon_pragmatic.webp": 48409,
	"./assets/images/navbar/icon_sport.svg": 7683,
	"./assets/images/navbar/icon_tv_games.svg": 81906,
	"./assets/images/navbar/megawin-navbar/crash.webp": 95710,
	"./assets/images/navbar/megawin-navbar/crash_active.webp": 50692,
	"./assets/images/navbar/megawin-navbar/favorite.webp": 29338,
	"./assets/images/navbar/megawin-navbar/favorite_active.webp": 2759,
	"./assets/images/navbar/megawin-navbar/games.webp": 70822,
	"./assets/images/navbar/megawin-navbar/games_active.webp": 49408,
	"./assets/images/navbar/megawin-navbar/live_casino.webp": 33135,
	"./assets/images/navbar/megawin-navbar/live_casino_active.webp": 31375,
	"./assets/images/navbar/megawin-navbar/virtual.webp": 28103,
	"./assets/images/navbar/megawin-navbar/virtual_active.webp": 88142,
	"./assets/images/navbar/megawin-sidebar/amatic.webp": 44296,
	"./assets/images/navbar/megawin-sidebar/download.webp": 67429,
	"./assets/images/navbar/megawin-sidebar/evolution.webp": 56373,
	"./assets/images/navbar/megawin-sidebar/fast_games.webp": 98838,
	"./assets/images/navbar/megawin-sidebar/languages.webp": 15512,
	"./assets/images/navbar/megawin-sidebar/live_casino.webp": 51072,
	"./assets/images/navbar/megawin-sidebar/live_sport.webp": 71099,
	"./assets/images/navbar/megawin-sidebar/my_bets.webp": 85042,
	"./assets/images/navbar/megawin-sidebar/pragmatic.webp": 54474,
	"./assets/images/navbar/megawin-sidebar/slots.webp": 29174,
	"./assets/images/navbar/megawin-sidebar/sport.webp": 6880,
	"./assets/images/navbar/megawin-sidebar/static_page.webp": 45524,
	"./assets/images/navbar/megawin_icon_amatic.webp": 8065,
	"./assets/images/navbar/megawin_icon_crash.webp": 35417,
	"./assets/images/navbar/megawin_icon_evolution.webp": 66288,
	"./assets/images/navbar/megawin_icon_live_casino.webp": 99536,
	"./assets/images/navbar/megawin_icon_live_sport.webp": 90345,
	"./assets/images/navbar/megawin_icon_my_bets.webp": 20950,
	"./assets/images/navbar/megawin_icon_pragmatic.webp": 66289,
	"./assets/images/navbar/megawin_icon_slots.webp": 20681,
	"./assets/images/navbar/megawin_icon_sport.webp": 81984,
	"./assets/images/navbar/mybet-sidebar/fast_games.webp": 36171,
	"./assets/images/navbar/mybet-sidebar/games.webp": 63326,
	"./assets/images/navbar/mybet-sidebar/languages.webp": 81451,
	"./assets/images/navbar/mybet-sidebar/live_sport.webp": 64594,
	"./assets/images/navbar/mybet-sidebar/nincato.webp": 64425,
	"./assets/images/navbar/mybet-sidebar/promotions.webp": 74975,
	"./assets/images/navbar/mybet-sidebar/sport.webp": 24836,
	"./assets/images/navbar/mybet-sidebar/static_page.webp": 22368,
	"./assets/images/navbar/mybet-sidebar/tv_games.webp": 8800,
	"./assets/images/navbar/mybet-sidebar/virtual.webp": 23069,
	"./assets/images/navbar_hall_of_fame_mobile.png": 88510,
	"./assets/images/profile_filter_icon.svg": 23521,
	"./assets/images/providers/provider_1x2Gaming_logo.png": 66157,
	"./assets/images/providers/provider_BB-games_logo.png": 39275,
	"./assets/images/providers/provider_Blueprint-Gaming_logo.png": 8380,
	"./assets/images/providers/provider_Booongo_logo.png": 32646,
	"./assets/images/providers/provider_Cq9_logo.png": 5107,
	"./assets/images/providers/provider_Dragon-soft_logo.png": 6200,
	"./assets/images/providers/provider_Evoplay_logo.png": 20381,
	"./assets/images/providers/provider_Fantasma-Games_logo.png": 64608,
	"./assets/images/providers/provider_Fugaso_logo.png": 62220,
	"./assets/images/providers/provider_Gamefish-Global_logo.png": 42382,
	"./assets/images/providers/provider_Gamzix_logo.png": 55791,
	"./assets/images/providers/provider_Habanero_logo.png": 69490,
	"./assets/images/providers/provider_Hacksaw_logo.png": 99028,
	"./assets/images/providers/provider_Iron-Dog_logo.png": 71607,
	"./assets/images/providers/provider_Kalamba-Games_logo.png": 57934,
	"./assets/images/providers/provider_Kiron_logo.png": 96283,
	"./assets/images/providers/provider_Lady-Luck_logo.png": 93033,
	"./assets/images/providers/provider_Maverick_logo.png": 8970,
	"./assets/images/providers/provider_Mobilots_logo.png": 80964,
	"./assets/images/providers/provider_NetGame_logo.png": 91755,
	"./assets/images/providers/provider_Netent_logo.png": 19450,
	"./assets/images/providers/provider_Nolimit-City_logo.png": 24590,
	"./assets/images/providers/provider_OMI-Gaming_logo.png": 43930,
	"./assets/images/providers/provider_OneTouch_logo.png": 13923,
	"./assets/images/providers/provider_Playngo_logo.png": 63683,
	"./assets/images/providers/provider_Playpearls_logo.png": 22735,
	"./assets/images/providers/provider_Playson_logo.png": 76000,
	"./assets/images/providers/provider_Pragmatic-Play_logo.png": 97661,
	"./assets/images/providers/provider_Print-Studios_logo.png": 91727,
	"./assets/images/providers/provider_Push-Gaming_logo.png": 74637,
	"./assets/images/providers/provider_Quickspin_logo.png": 99405,
	"./assets/images/providers/provider_Red-Tiger_logo.png": 88314,
	"./assets/images/providers/provider_Relax-Gaming_logo.png": 31412,
	"./assets/images/providers/provider_Rtg-Slots_logo.png": 46849,
	"./assets/images/providers/provider_Skywind-Group_logo.png": 93820,
	"./assets/images/providers/provider_Slotmill_logo.png": 46397,
	"./assets/images/providers/provider_Spearhead_logo.png": 60897,
	"./assets/images/providers/provider_Splitrock_logo.png": 67640,
	"./assets/images/providers/provider_Thunderkick_logo.png": 3050,
	"./assets/images/providers/provider_Tpg_logo.png": 92742,
	"./assets/images/providers/provider_Wazdan_logo.png": 29635,
	"./assets/images/providers/provider_Yggdrasil_logo.png": 43666,
	"./assets/images/providers/provider_amatic_logo.png": 31917,
	"./assets/images/providers/provider_apollo_logo.png": 71718,
	"./assets/images/providers/provider_aristocrat_logo.png": 65837,
	"./assets/images/providers/provider_ebet_logo.png": 87174,
	"./assets/images/providers/provider_evolution_logo.png": 82056,
	"./assets/images/providers/provider_ezugi_logo.png": 96412,
	"./assets/images/providers/provider_gameart_logo.png": 14632,
	"./assets/images/providers/provider_greentube_logo.png": 92074,
	"./assets/images/providers/provider_igrosoft_logo.png": 38627,
	"./assets/images/providers/provider_igt_logo.png": 92979,
	"./assets/images/providers/provider_kajot_logo.png": 48949,
	"./assets/images/providers/provider_konami_logo.png": 87219,
	"./assets/images/providers/provider_merkur_logo.png": 55605,
	"./assets/images/providers/provider_microgaming_logo.png": 16192,
	"./assets/images/providers/provider_playtech_logo.png": 78000,
	"./assets/images/search_icon.svg": 41122,
	"./assets/images/social/facebook.svg": 52863,
	"./assets/images/social/instagram.svg": 77602,
	"./assets/images/theme/dark.svg": 90966,
	"./assets/images/theme/light.svg": 53194,
	"./assets/images/tv_games_banner_icon.webp": 21864,
	"./assets/images/tv_games_megawin_banner_icon.webp": 47988,
	"./assets/images/tv_games_megawin_mobile_banner.webp": 99125,
	"./assets/images/tv_games_megawin_tablet_banner.webp": 91324,
	"./assets/loaders/AppLoader": 34030,
	"./assets/loaders/AppLoader.tsx": 34030,
	"./assets/loaders/ButtonLottie": 15140,
	"./assets/loaders/ButtonLottie.tsx": 15140,
	"./assets/loaders/StarLottie": 6863,
	"./assets/loaders/StarLottie.tsx": 6863,
	"./assets/loaders/izibet.svg": 47814,
	"./assets/loaders/megawin.webp": 14524,
	"./assets/loaders/mybet.webp": 76430,
	"./assets/lotties/load_lottie": 87464,
	"./assets/lotties/load_lottie.json": 87464,
	"./assets/lotties/loading_button_lottie": 60557,
	"./assets/lotties/loading_button_lottie.json": 60557,
	"./assets/lotties/loading_lottie": 11957,
	"./assets/lotties/loading_lottie.json": 11957,
	"./assets/lotties/lottie_loading": 35792,
	"./assets/lotties/lottie_loading.json": 35792,
	"./assets/lotties/star_lottie": 51877,
	"./assets/lotties/star_lottie.json": 51877,
	"./components/containers/CategoriesContainer": 28448,
	"./components/containers/CategoriesContainer.tsx": 28448,
	"./components/containers/MainCards": 82578,
	"./components/containers/MainCards.tsx": 82578,
	"./components/containers/MostLikedGamesContainer": 16108,
	"./components/containers/MostLikedGamesContainer.tsx": 16108,
	"./components/containers/PromotionsCards": 5817,
	"./components/containers/PromotionsCards.tsx": 5817,
	"./components/containers/ProvidersSwiper": 55189,
	"./components/containers/ProvidersSwiper.tsx": 55189,
	"./components/errorWindow/ErrorWindow": 19595,
	"./components/errorWindow/ErrorWindow.tsx": 19595,
	"./components/games/DesktopGame": 84142,
	"./components/games/DesktopGame.tsx": 84142,
	"./components/modals/AlertCleanCache": 61798,
	"./components/modals/AlertCleanCache.tsx": 61798,
	"./components/modals/CashbackModal": 25232,
	"./components/modals/CashbackModal.tsx": 25232,
	"./components/modals/PopupModal": 4863,
	"./components/modals/PopupModal.tsx": 4863,
	"./components/modals/ProfileModal": 7501,
	"./components/modals/ProfileModal.tsx": 7501,
	"./components/modals/PromotionModal": 18517,
	"./components/modals/PromotionModal.tsx": 18517,
	"./components/modals/ProvidersModal": 32485,
	"./components/modals/ProvidersModal.tsx": 32485,
	"./components/modals/SignInModal": 42507,
	"./components/modals/SignInModal.tsx": 42507,
	"./components/profile/ChangePasswordWrapper": 63850,
	"./components/profile/ChangePasswordWrapper.tsx": 63850,
	"./components/profile/DesktopWrapper": 87159,
	"./components/profile/DesktopWrapper.tsx": 87159,
	"./components/profile/MessagesWrapper": 96045,
	"./components/profile/MessagesWrapper.tsx": 96045,
	"./components/profile/MobileWrapper": 33807,
	"./components/profile/MobileWrapper.tsx": 33807,
	"./components/profile/PersonalDataWrapper": 74541,
	"./components/profile/PersonalDataWrapper.tsx": 74541,
	"./components/profile/ProfileHistoryWrapper": 18382,
	"./components/profile/ProfileHistoryWrapper.tsx": 18382,
	"./components/scrollButton": 2944,
	"./components/scrollButton/": 2944,
	"./components/scrollButton/index": 2944,
	"./components/scrollButton/index.tsx": 2944,
	"./components/seo": 4170,
	"./components/seo/": 4170,
	"./components/seo/index": 4170,
	"./components/seo/index.tsx": 4170,
	"./components/slider": 5002,
	"./components/slider/": 5002,
	"./components/slider/index": 5002,
	"./components/slider/index.tsx": 5002,
	"./components/socialMedia": 35579,
	"./components/socialMedia/": 35579,
	"./components/socialMedia/index": 35579,
	"./components/socialMedia/index.tsx": 35579,
	"./components/sport/DigitainSport": 30614,
	"./components/sport/DigitainSport.tsx": 30614,
	"./components/sport/GaminghubSport": 70668,
	"./components/sport/GaminghubSport.tsx": 70668,
	"./components/sport/MondoSport": 11765,
	"./components/sport/MondoSport.tsx": 11765,
	"./components/sport/SpSport": 96551,
	"./components/sport/SpSport.tsx": 96551,
	"./components/wrapper/drawer": 91245,
	"./components/wrapper/drawer-new/DrawerContent": 69023,
	"./components/wrapper/drawer-new/DrawerContent.tsx": 69023,
	"./components/wrapper/drawer-new/LanguageController": 3360,
	"./components/wrapper/drawer-new/LanguageController.tsx": 3360,
	"./components/wrapper/drawer-new/Navigator": 65101,
	"./components/wrapper/drawer-new/Navigator.tsx": 65101,
	"./components/wrapper/drawer/": 91245,
	"./components/wrapper/drawer/DrawerContent": 96633,
	"./components/wrapper/drawer/DrawerContent.tsx": 96633,
	"./components/wrapper/drawer/DrawerFooter": 72500,
	"./components/wrapper/drawer/DrawerFooter.tsx": 72500,
	"./components/wrapper/drawer/DrawerHallOfFameContent": 7895,
	"./components/wrapper/drawer/DrawerHallOfFameContent.tsx": 7895,
	"./components/wrapper/drawer/index": 91245,
	"./components/wrapper/drawer/index.tsx": 91245,
	"./components/wrapper/footer/FooterDesktop": 86392,
	"./components/wrapper/footer/FooterDesktop.tsx": 86392,
	"./components/wrapper/footer/FooterMobile": 31918,
	"./components/wrapper/footer/FooterMobile.tsx": 31918,
	"./components/wrapper/footer/List": 7211,
	"./components/wrapper/footer/List.tsx": 7211,
	"./components/wrapper/header": 45685,
	"./components/wrapper/header/": 45685,
	"./components/wrapper/header/HeaderDesktop": 60358,
	"./components/wrapper/header/HeaderDesktop.tsx": 60358,
	"./components/wrapper/header/InfoContainer": 32770,
	"./components/wrapper/header/InfoContainer.tsx": 32770,
	"./components/wrapper/header/LanguageContainer": 70208,
	"./components/wrapper/header/LanguageContainer.tsx": 70208,
	"./components/wrapper/header/NavBar": 76485,
	"./components/wrapper/header/NavBar.tsx": 76485,
	"./components/wrapper/header/ProfileContainer": 74972,
	"./components/wrapper/header/ProfileContainer.tsx": 74972,
	"./components/wrapper/header/SecondHeaderDesktop": 36615,
	"./components/wrapper/header/SecondHeaderDesktop.tsx": 36615,
	"./components/wrapper/header/ThemeSwitch": 99928,
	"./components/wrapper/header/ThemeSwitch.tsx": 99928,
	"./components/wrapper/header/index": 45685,
	"./components/wrapper/header/index.tsx": 45685,
	"./components/wrapper/mobileFooter": 40468,
	"./components/wrapper/mobileFooter/": 40468,
	"./components/wrapper/mobileFooter/NavbarItem": 24130,
	"./components/wrapper/mobileFooter/NavbarItem.tsx": 24130,
	"./components/wrapper/mobileFooter/index": 40468,
	"./components/wrapper/mobileFooter/index.tsx": 40468,
	"./components/wrapper/mobileFooter/mask.svg": 34883,
	"./constants/config": 43107,
	"./constants/config.ts": 43107,
	"./constants/deviceSizes": 48584,
	"./constants/deviceSizes.ts": 48584,
	"./constants/helperValidation": 51144,
	"./constants/helperValidation.ts": 51144,
	"./constants/regExp": 61281,
	"./constants/regExp.ts": 61281,
	"./constants/routingLinks": 36275,
	"./constants/routingLinks.tsx": 36275,
	"./helpers/HighOrderThemeProvider": 34069,
	"./helpers/HighOrderThemeProvider.tsx": 34069,
	"./helpers/ReactWindowScroller": 49281,
	"./helpers/ReactWindowScroller.tsx": 49281,
	"./helpers/checkProps": 18572,
	"./helpers/checkProps.ts": 18572,
	"./helpers/formatColors": 17417,
	"./helpers/formatColors.ts": 17417,
	"./helpers/formatDate": 88400,
	"./helpers/formatDate.ts": 88400,
	"./helpers/formatString": 33032,
	"./helpers/formatString.ts": 33032,
	"./helpers/generate": 63825,
	"./helpers/generate.ts": 63825,
	"./helpers/openGame": 23391,
	"./helpers/openGame.ts": 23391,
	"./helpers/openLink": 99356,
	"./helpers/openLink.ts": 99356,
	"./helpers/providerHelper": 35336,
	"./helpers/providerHelper/": 35336,
	"./helpers/providerHelper/index": 35336,
	"./helpers/providerHelper/index.tsx": 35336,
	"./helpers/providerHelper/providersImages": 29438,
	"./helpers/providerHelper/providersImages.ts": 29438,
	"./helpers/selectors": 3569,
	"./helpers/selectors.ts": 3569,
	"./hooks/ReactWindowScroller": 88640,
	"./hooks/ReactWindowScroller.tsx": 88640,
	"./hooks/useAddTagToHtml": 75514,
	"./hooks/useAddTagToHtml.ts": 75514,
	"./hooks/useAverageColor": 70159,
	"./hooks/useAverageColor.ts": 70159,
	"./hooks/useBodyOverflow": 77950,
	"./hooks/useBodyOverflow.ts": 77950,
	"./hooks/useCustomToast": 41804,
	"./hooks/useCustomToast.ts": 41804,
	"./hooks/useDebounce": 73598,
	"./hooks/useDebounce.ts": 73598,
	"./hooks/useEventListener": 15560,
	"./hooks/useEventListener.ts": 15560,
	"./hooks/useInput": 56803,
	"./hooks/useInput.ts": 56803,
	"./hooks/useInterval": 88129,
	"./hooks/useInterval.ts": 88129,
	"./hooks/useKeyPress": 46211,
	"./hooks/useKeyPress.ts": 46211,
	"./hooks/useMediaQuery": 24635,
	"./hooks/useMediaQuery.ts": 24635,
	"./hooks/useOutsideClick": 50061,
	"./hooks/useOutsideClick.ts": 50061,
	"./hooks/usePortal": 83683,
	"./hooks/usePortal.ts": 83683,
	"./hooks/useScript": 33745,
	"./hooks/useScript.ts": 33745,
	"./hooks/useStorage": 46091,
	"./hooks/useStorage.ts": 46091,
	"./hooks/useTestValidation": 14922,
	"./hooks/useTestValidation.ts": 14922,
	"./hooks/useTime": 96915,
	"./hooks/useTime.ts": 96915,
	"./hooks/useTypedRedux": 68654,
	"./hooks/useTypedRedux.ts": 68654,
	"./hooks/useValidate": 95021,
	"./hooks/useValidate.ts": 95021,
	"./i18n": 5861,
	"./i18n.ts": 5861,
	"./index": 67672,
	"./index.css": 51174,
	"./index.tsx": 67672,
	"./interfaces": 24832,
	"./interfaces/": 24832,
	"./interfaces/index": 24832,
	"./interfaces/index.ts": 24832,
	"./interfaces/modal": 26363,
	"./interfaces/modal.ts": 26363,
	"./interfaces/table": 41347,
	"./interfaces/table.ts": 41347,
	"./pages/ErrorBoundaryPage": 15486,
	"./pages/ErrorBoundaryPage.tsx": 15486,
	"./pages/Game": 23132,
	"./pages/Game.tsx": 23132,
	"./pages/Games.desktop/Games.desktop": 12983,
	"./pages/Games.desktop/Games.desktop.tsx": 12983,
	"./pages/Games.desktop/GamesListContainer.desktop": 86154,
	"./pages/Games.desktop/GamesListContainer.desktop.tsx": 86154,
	"./pages/Games.desktop/GamesPageContainer.desktop": 42378,
	"./pages/Games.desktop/GamesPageContainer.desktop.tsx": 42378,
	"./pages/Games.desktop/GamesVirtualListContainer.desktop": 81234,
	"./pages/Games.desktop/GamesVirtualListContainer.desktop.tsx": 81234,
	"./pages/Games/Games": 18255,
	"./pages/Games/Games.tsx": 18255,
	"./pages/Games/GamesPageContainer": 88375,
	"./pages/Games/GamesPageContainer.tsx": 88375,
	"./pages/Games/GamesVirtualListContainer": 36624,
	"./pages/Games/GamesVirtualListContainer.tsx": 36624,
	"./pages/Horses": 49305,
	"./pages/Horses.tsx": 49305,
	"./pages/Main": 16158,
	"./pages/Main.desktop": 78684,
	"./pages/Main.desktop.tsx": 78684,
	"./pages/Main.tsx": 16158,
	"./pages/Promotions": 12775,
	"./pages/Promotions.tsx": 12775,
	"./pages/Sport": 93896,
	"./pages/Sport.tsx": 93896,
	"./pages/StaticPage": 32982,
	"./pages/StaticPage.tsx": 32982,
	"./pages/TvGames.desktop/TvGames.desktop": 92449,
	"./pages/TvGames.desktop/TvGames.desktop.tsx": 92449,
	"./pages/TvGames.desktop/TvGamesListContainer": 11703,
	"./pages/TvGames.desktop/TvGamesListContainer.tsx": 11703,
	"./pages/TvGames.desktop/TvGamesListContainerFeature": 5860,
	"./pages/TvGames.desktop/TvGamesListContainerFeature.tsx": 5860,
	"./pages/TvGames/TvGames": 54781,
	"./pages/TvGames/TvGames.tsx": 54781,
	"./pages/TvGames/TvGamesListContainer": 37415,
	"./pages/TvGames/TvGamesListContainer.tsx": 37415,
	"./pages/hallOfFame/HallOfFame": 43526,
	"./pages/hallOfFame/HallOfFame.mobile": 1511,
	"./pages/hallOfFame/HallOfFame.mobile.tsx": 1511,
	"./pages/hallOfFame/HallOfFame.tsx": 43526,
	"./pages/hallOfFame/HallOfFameComponents": 4442,
	"./pages/hallOfFame/HallOfFameComponents.tsx": 4442,
	"./pages/profile/BetHistory": 28969,
	"./pages/profile/BetHistory.desktop": 15776,
	"./pages/profile/BetHistory.desktop.tsx": 15776,
	"./pages/profile/BetHistory.tsx": 28969,
	"./pages/profile/CashbackHistory": 18284,
	"./pages/profile/CashbackHistory.desktop": 45049,
	"./pages/profile/CashbackHistory.desktop.tsx": 45049,
	"./pages/profile/CashbackHistory.tsx": 18284,
	"./pages/profile/ChangePassword": 40444,
	"./pages/profile/ChangePassword.desktop": 19480,
	"./pages/profile/ChangePassword.desktop.tsx": 19480,
	"./pages/profile/ChangePassword.tsx": 40444,
	"./pages/profile/Messages": 15190,
	"./pages/profile/Messages.desktop": 69151,
	"./pages/profile/Messages.desktop.tsx": 69151,
	"./pages/profile/Messages.tsx": 15190,
	"./pages/profile/OperationsHistory": 72137,
	"./pages/profile/OperationsHistory.desktop": 71257,
	"./pages/profile/OperationsHistory.desktop.tsx": 71257,
	"./pages/profile/OperationsHistory.tsx": 72137,
	"./pages/profile/PersonalData": 51566,
	"./pages/profile/PersonalData.desktop": 66881,
	"./pages/profile/PersonalData.desktop.tsx": 66881,
	"./pages/profile/PersonalData.tsx": 51566,
	"./react-app-env.d": 44398,
	"./react-app-env.d.ts": 44398,
	"./redux/api/appApi": 82947,
	"./redux/api/appApi.ts": 82947,
	"./redux/api/commonApi": 15446,
	"./redux/api/commonApi.ts": 15446,
	"./redux/api/gamesApi": 56590,
	"./redux/api/gamesApi.ts": 56590,
	"./redux/api/hallOfFameApi": 55727,
	"./redux/api/hallOfFameApi.ts": 55727,
	"./redux/api/transactionApi": 5326,
	"./redux/api/transactionApi.ts": 5326,
	"./redux/api/userApi": 50960,
	"./redux/api/userApi.ts": 50960,
	"./redux/middlewares": 36399,
	"./redux/middlewares/": 36399,
	"./redux/middlewares/appMiddleware": 89045,
	"./redux/middlewares/appMiddleware.ts": 89045,
	"./redux/middlewares/gamesMiddleware": 270,
	"./redux/middlewares/gamesMiddleware.ts": 270,
	"./redux/middlewares/hallOfFameMiddleware": 10921,
	"./redux/middlewares/hallOfFameMiddleware.ts": 10921,
	"./redux/middlewares/index": 36399,
	"./redux/middlewares/index.ts": 36399,
	"./redux/middlewares/userMiddleware": 92238,
	"./redux/middlewares/userMiddleware.ts": 92238,
	"./redux/selectors/appSelector": 8364,
	"./redux/selectors/appSelector.ts": 8364,
	"./redux/selectors/gamesSelector": 99491,
	"./redux/selectors/gamesSelector.ts": 99491,
	"./redux/selectors/hallOfFameSelectors": 58346,
	"./redux/selectors/hallOfFameSelectors.ts": 58346,
	"./redux/selectors/userSelector": 72395,
	"./redux/selectors/userSelector.ts": 72395,
	"./redux/slices/appSlice": 32806,
	"./redux/slices/appSlice.ts": 32806,
	"./redux/slices/gamesSlice": 14795,
	"./redux/slices/gamesSlice.ts": 14795,
	"./redux/slices/hallOfFame": 11185,
	"./redux/slices/hallOfFame.ts": 11185,
	"./redux/slices/transactionSlice": 11142,
	"./redux/slices/transactionSlice.ts": 11142,
	"./redux/slices/userSlice": 653,
	"./redux/slices/userSlice.ts": 653,
	"./redux/store": 95027,
	"./redux/store.ts": 95027,
	"./redux/types": 20941,
	"./redux/types/": 20941,
	"./redux/types/appTypes": 26175,
	"./redux/types/appTypes.ts": 26175,
	"./redux/types/gamesTypes": 36022,
	"./redux/types/gamesTypes.ts": 36022,
	"./redux/types/hallOfFame": 64626,
	"./redux/types/hallOfFame.ts": 64626,
	"./redux/types/index": 20941,
	"./redux/types/index.ts": 20941,
	"./redux/types/transactionTypes": 80249,
	"./redux/types/transactionTypes.ts": 80249,
	"./redux/types/userTypes": 96963,
	"./redux/types/userTypes.ts": 96963,
	"./reportWebVitals": 58983,
	"./reportWebVitals.ts": 58983,
	"./routes": 11381,
	"./routes/": 11381,
	"./routes/desktop-app": 83290,
	"./routes/desktop-app.tsx": 83290,
	"./routes/index": 11381,
	"./routes/index.tsx": 11381,
	"./routes/mobile-app": 30835,
	"./routes/mobile-app.tsx": 30835,
	"./routes/routing": 86358,
	"./routes/routing.tsx": 86358,
	"./service-worker": 31943,
	"./service-worker.ts": 31943,
	"./serviceWorkerRegistration": 82305,
	"./serviceWorkerRegistration.ts": 82305,
	"./services/GoogleMetrics": 73321,
	"./services/GoogleMetrics.tsx": 73321,
	"./services/PortalService": 34584,
	"./services/PortalService.tsx": 34584,
	"./services/SocketService": 51931,
	"./services/SocketService.tsx": 51931,
	"./services/TawkService": 77022,
	"./services/TawkService.ts": 77022,
	"./services/YandexMetrics": 64272,
	"./services/YandexMetrics.tsx": 64272,
	"./services/betbbyService": 28625,
	"./services/betbbyService.ts": 28625,
	"./settings": 11080,
	"./settings/": 11080,
	"./settings/ISettings": 85483,
	"./settings/ISettings.ts": 85483,
	"./settings/index": 11080,
	"./settings/index.ts": 11080,
	"./settings/izibet_settings": 22879,
	"./settings/izibet_settings.json": 22879,
	"./settings/local_settings": 90183,
	"./settings/local_settings.json": 90183,
	"./settings/megawin_settings": 76878,
	"./settings/megawin_settings.json": 76878,
	"./settings/mybet_settings": 82799,
	"./settings/mybet_settings.json": 82799,
	"./theme": 9618,
	"./theme/": 9618,
	"./theme/ITheme": 59971,
	"./theme/ITheme.ts": 59971,
	"./theme/IzibetTheme": 26054,
	"./theme/IzibetTheme.ts": 26054,
	"./theme/MegawinTheme": 14917,
	"./theme/MegawinTheme.ts": 14917,
	"./theme/index": 9618,
	"./theme/index.ts": 9618,
	"./theme/styled.d": 15489,
	"./theme/styled.d.ts": 15489,
	"./ui/ArrowButton": 33124,
	"./ui/ArrowButton.tsx": 33124,
	"./ui/ContainerTitle": 76240,
	"./ui/ContainerTitle.tsx": 76240,
	"./ui/CurrentDate": 23952,
	"./ui/CurrentDate.tsx": 23952,
	"./ui/CustomDatePicker": 55987,
	"./ui/CustomDatePicker.tsx": 55987,
	"./ui/CustomModal": 55177,
	"./ui/CustomModal.tsx": 55177,
	"./ui/DesktopProfileMenu": 2828,
	"./ui/DesktopProfileMenu.tsx": 2828,
	"./ui/ExternalContent": 56412,
	"./ui/ExternalContent.tsx": 56412,
	"./ui/FilterDateCustom": 42049,
	"./ui/FilterDateCustom.tsx": 42049,
	"./ui/FooterColumnContainer": 13284,
	"./ui/FooterColumnContainer.tsx": 13284,
	"./ui/GameCard": 81560,
	"./ui/GameCard.tsx": 81560,
	"./ui/HistoryItem": 66826,
	"./ui/HistoryItem.tsx": 66826,
	"./ui/JackpotStarMobile": 24504,
	"./ui/JackpotStarMobile.tsx": 24504,
	"./ui/JackpotStarsDesktop": 37922,
	"./ui/JackpotStarsDesktop.tsx": 37922,
	"./ui/LazyImage": 44060,
	"./ui/LazyImage.tsx": 44060,
	"./ui/ListMenu": 34847,
	"./ui/ListMenu.tsx": 34847,
	"./ui/Loader/Loader": 20091,
	"./ui/Loader/Loader.css": 78576,
	"./ui/Loader/Loader.tsx": 20091,
	"./ui/MainGamesBlock": 69317,
	"./ui/MainGamesBlock.tsx": 69317,
	"./ui/Modal": 59512,
	"./ui/Modal.tsx": 59512,
	"./ui/ModalProfileItem": 39731,
	"./ui/ModalProfileItem.tsx": 39731,
	"./ui/Pagination": 37169,
	"./ui/Pagination.tsx": 37169,
	"./ui/PrettyToast": 59061,
	"./ui/PrettyToast.tsx": 59061,
	"./ui/ProfileLinks": 95561,
	"./ui/ProfileLinks.tsx": 95561,
	"./ui/ProviderAccordion": 40940,
	"./ui/ProviderAccordion.tsx": 40940,
	"./ui/SelectButton": 22964,
	"./ui/SelectButton.tsx": 22964,
	"./ui/cards/DesktopCard": 74741,
	"./ui/cards/DesktopCard.tsx": 74741,
	"./ui/cards/MainCard": 46025,
	"./ui/cards/MainCard.tsx": 46025,
	"./ui/containers": 61719,
	"./ui/containers.tsx": 61719,
	"./ui/material-kit/Button": 75082,
	"./ui/material-kit/Button.tsx": 75082,
	"./ui/material-kit/Checkbox": 6803,
	"./ui/material-kit/Checkbox.tsx": 6803,
	"./ui/material-kit/Drawer": 25671,
	"./ui/material-kit/Drawer.tsx": 25671,
	"./ui/material-kit/IconButton": 69689,
	"./ui/material-kit/IconButton.tsx": 69689,
	"./ui/material-kit/ImageIcon": 63175,
	"./ui/material-kit/ImageIcon.tsx": 63175,
	"./ui/material-kit/Input": 11796,
	"./ui/material-kit/Input.tsx": 11796,
	"./ui/material-kit/ListMenu": 8486,
	"./ui/material-kit/ListMenu.tsx": 8486,
	"./ui/material-kit/Modal": 37498,
	"./ui/material-kit/Modal.tsx": 37498,
	"./ui/material-kit/MultipleSelector": 83695,
	"./ui/material-kit/MultipleSelector.tsx": 83695,
	"./ui/material-kit/Search": 1670,
	"./ui/material-kit/Search.tsx": 1670,
	"./ui/material-kit/Selector": 15537,
	"./ui/material-kit/Selector.tsx": 15537,
	"./ui/material-kit/SmartSearchSelect": 68134,
	"./ui/material-kit/SmartSearchSelect.tsx": 68134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;